export default __webpack_public_path__ + "static/media/img_maintenance.5f6435ec.png";